import axios, { AxiosInstance } from "axios";

const baseURL = '';

export const axiosInstance: AxiosInstance = axios.create({
  baseURL,
});

export const setAxiosBaseURL = (url: string) => {
  axiosInstance.defaults.baseURL = url;
};